import { defineAsyncComponent } from 'vue'
export default {
  app: defineAsyncComponent(() => import("/codebuild/output/src2808178616/src/web-front-end/layouts/app.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/codebuild/output/src2808178616/src/web-front-end/layouts/default.vue").then(m => m.default || m))
}